module.exports = __webpack_public_path__ + "img/model_49_ug.d92ad0b6.jpg";